import { useTranslation } from 'react-i18next';
import './ErrorPage.css';
import { ErrorSidebar } from '@/components/Common/Error/ErrorSidebar';
import { ErrorDisplay } from '@/components/Common/Error/ErrorDisplay';
import { I18N_KEYS } from '@/language/keys';

export const WebGLNotSupportedPage = () => {
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <ErrorSidebar />
      <ErrorDisplay
        title={t(I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.TITLE)}
        description={t(I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.DESCRIPTION)}
        actions={[]}
      />
    </div>
  );
};
